import React from "react";

import * as S from "./styled";

const SellMainNavLink = () => (
  <S.MainNavLink
    ariaLabel="Sell Your Home"
    href="/sell-your-home"
    isNew
    title="Sell"
  />
);

export default SellMainNavLink;
